import $ from 'cash-dom'
import { getCheckoutAddressParams } from './cart-checkout-BYGS'
import { getCart, updateCart } from '../resources/shopify-cart'

const checkoutButton = $('[data-action="checkout"]')
const agreeToSubscriptionTerms = $(
  '[data-action="agree-to-subscription-terms"]'
)
let cartToken = ''
let discountCode, discountCodeRule

checkoutButton.on('click', (e) => {
  e.preventDefault()

  getCart()
    .then((cart) => {
      cartToken = cart.token

      let addressParams = getCheckoutAddressParams(cart)

      // Check if user has already accepted terms
      const hasAcceptedTerms = cart.attributes?._subscription_terms_accepted === 'true'

      // If we have locked items and user hasn't accepted terms, show modal
      if (hasLockedItem(cart) && !hasAcceptedTerms) {
        let modalTermsPanel = document.getElementById(
          'free-diffuser-terms-panel'
        )
        if (modalTermsPanel) {
          modalTermsPanel.show()
        }
        return
      }

      // check for auto apply discount code
      let discountCodeItem = getAutoApplyDiscountCodeItem(cart.items)
      if (discountCodeItem) {
        discountCode =
          discountCodeItem.properties._pura_auto_apply_discount.toUpperCase()
      }

      if (discountCode) {
        window.location = `/checkout?discount=${discountCode}`
        return
      }

      window.location = `/checkout?${addressParams}`
    })
    .catch((error) => {
      console.log('error getting cart for recharge', error)
    })
})

agreeToSubscriptionTerms.on('click', (e) => {
  e.preventDefault()

  // Record the terms acceptance with timestamp
  const acceptanceTimestamp = new Date().toISOString()

  updateCart({
    attributes: {
      _subscription_terms_accepted: 'true',
      _subscription_terms_accepted_at: acceptanceTimestamp
    }
  })
    .then(() => {
      let url = '/checkout'
      if (discountCode) {
        url += `?discount=${discountCode}`
      }
      window.location = url
    })
    .catch((error) => {
      console.error('Error recording terms acceptance:', error)
      // Still proceed to checkout even if recording fails
      let url = '/checkout'
      if (discountCode) {
        url += `?discount=${discountCode}`
      }
      window.location = url
    })
})

const hasSubscriptionItem = (cart) => {
  let item,
    items = cart.items
  for (let i = 0; i < items.length; ++i) {
    item = items[i]
    if (item.selling_plan != null) {
      return true
    }
  }
  return false
}

const hasLockedItem = (cart) => {
  let item,
    items = cart.items
  for (let i = 0; i < items.length; ++i) {
    item = items[i]
    if (item.properties != null && item.properties._pura_lock_duration > 0) {
      return true
    }
  }
  return false
}

const getAutoApplyDiscountCodeItem = (items) => {
  let item
  for (let i = 0; i < items.length; ++i) {
    item = items[i]
    if (
      item.properties != null &&
      item.properties._pura_auto_apply_discount != null
    ) {
      return item
    }
  }
  return false
}

export { hasSubscriptionItem }
